import React, { useEffect, useState } from "react";
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useMediaQuery, useTheme, FormHelperText } from '@mui/material';
import { Link, useHistory } from "react-router-dom";
import axios from 'axios';
import swal from 'sweetalert';
import Navbar from '../../frontend/abstact/Navbar';
import IconButton from '@mui/material/IconButton';
import PhotoCamera from '@mui/icons-material/PhotoCamera';
import { useLocation } from 'react-router-dom';
import WorkshopNavbar from "../../frontend/WorkShop/WorkshopNavbar/WorkshopNavbar";
import ConferenceNavbar from "../../frontend/Conference/ConferenceNavbar";
import NewVersionAbstractFooter from "../AbstractAuth/NewVersion/NewVersionAnstractFooter";
import { useDeadline } from "../../contexts/DeadlineContext";
const theme = createTheme();

const ConferenceBankPayemntForm = () => {
    const { offButton, abstractHomeSetup, getAbstractDeadLineStatus } = useDeadline();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const gradientBackground = '#05597D';


    const history = useHistory();
    const location = useLocation();
    const URL = window.location.href;
    const bankVerifiction = document.URL.split("/").slice(-1)[0];
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const [addBank, setAddBank] = useState({
        // participant_id: `${participantSingleData.id || ""}`,
        participant_bank: "",
        participant_ref_no: "",
        error_list: [],

    });

    const [participantData, setParticipantData] = useState({});
    React.useEffect(() => {
        axios.get(`api/conference-bank-verifiction/${bankVerifiction}`).then(res => {

            if (res.status === 200) {
                const FieldList = res.data.updateparticipantForm;
                setParticipantData(FieldList)

            } else {
                swal('Error', "Check API Something Wrong", 'error');

            }
        })

    }, []);




    const [bankReceipt, setBankReceipt] = useState("");
    localStorage.setItem('eventid', participantData?.event_id);



    const eventid = localStorage.getItem('eventid')
    const bankDetailSubmit = (e) => {
        e.preventDefault();
        const bankVerifictions = "bankVerifictions";
        const participant_id = participantData.id;
        const participantId = participantData.id;
        const event_id = participantData.event_id;
        const data = {

            // participant_id: `${participantSingleData.id || ""}`,
            event_id,
            participant_bank: addBank.participant_bank,
            participant_ref_no: addBank.participant_ref_no,
            bankVerifictions,
            participant_id,
            bankReceipt,

        }
        if (data.participant_bank === "" || data.participant_ref_no === "" || data.bankReceipt === "") {

            setIsSubmitting(false);
        }
        else {
            setIsSubmitting(true);
        }
        axios.get('/sanctum/csrf-cookie').then(response => {
            const config = {
                headers: { 'content-type': 'multipart/form-data' }
            }

            axios.post(`/api/conference-particepant-bank-verification-participant`, data, config).then(res => {

                if (res.data.status === 200) {

                    swal('Success', res.data.message, 'success');
                    //history.push('/login');
                    history.push(`/conference/thank-you/${participantId}`);
                }
                else {

                    setAddBank({ ...addBank, error_list: res.data.validate_error })

                }

            });


        });
        setAddBank({
            //participant_id: `${participantSingleData.id || ""}`,
            participant_bank: "",
            participant_ref_no: "",
            error_list: [],

        });
        setBankReceipt({
            bankReceipt: "",
        });

    }
    return (
        <div>
            <Grid item item xs={12} sm={10} md={8} lg={6}>
                <ConferenceNavbar />
            </Grid>
            <ThemeProvider theme={theme}>
                <Box
                    sx={{
                        position: 'relative',
                        //
                        //marginTop: '10px',
                        width: '100%',
                        height: isSmallScreen ? '200px' : '400px',
                        backgroundImage: `url(${(abstractHomeSetup?.conferenceBannerImage) || "https://via.placeholder.com/800x600"})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        display: 'flex',
                        alignItems: 'flex-end',
                        justifyContent: isSmallScreen ? 'center' : 'left',
                        padding: isSmallScreen ? '10px' : '20px',
                        color: 'white',
                    }}
                >
                    <Typography variant={isSmallScreen ? 'h6' : 'h2'} component="div">
                        {participantData?.cpcategory?.event_name} Conference Bank Form
                    </Typography>
                </Box>
                <Container component="main" maxWidth="xs">

                    <CssBaseline />
                    <Box
                        sx={{
                            marginTop: 8,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >
                        <Avatar sx={{ m: 1, backgroundColor: '#145348' }}>
                            <LockOutlinedIcon />
                        </Avatar>

                        {/* <Typography style={{ color: 'red' }}>
  
              {registerInput.error_list.eventid  ? '* '  + " " +" You probably came through a wrong link Please Register from the conference Website Thank you.." :""}  
              </Typography> */}

                        <Box component="form" onSubmit={bankDetailSubmit} noValidate sx={{ mt: 3 }}>
                            <Grid container spacing={2}>

                                <TextField
                                    label="Invoice No"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    name='participant_id'
                                    value={`INV${participantData?.id || ""}`}
                                    disabled={true} />
                                <TextField
                                    label="Bank Name"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    value={addBank.participant_bank}
                                    onChange={(e) => setAddBank({ ...addBank, participant_bank: e.target.value })}
                                    error={!!addBank.error_list?.participant_bank}
                                    helperText={addBank.error_list?.participant_bank}

                                />
                                <TextField
                                    label="Ref Number"
                                    variant="outlined"
                                    fullWidth
                                    margin="normal"
                                    value={addBank.participant_ref_no}
                                    onChange={(e) => setAddBank({ ...addBank, participant_ref_no: e.target.value })}
                                    error={!!addBank.error_list?.participant_ref_no}
                                    helperText={addBank.error_list?.participant_ref_no}

                                />
                                <label htmlFor="icon-button-file">
                                    <TextField id="icon-button-file" type="file" onChange={(e) => setBankReceipt(e.target.files[0])} name="[licenseFile]" />
                                    <IconButton color="primary" aria-label="upload picture" component="span"
                                    > Bank Receipt
                                        <PhotoCamera />
                                    </IconButton>
                                </label>

                                <FormHelperText>{addBank.error_list?.bankReceipt}</FormHelperText>
                            </Grid>
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2, background: abstractHomeSetup.color_code_two || gradientBackground, }}
                                disabled={isSubmitting} // Disable button when submitting
                            >
                                {isSubmitting ? 'Submitting...' : 'Save'}
                            </Button>

                        </Box>
                    </Box>

                </Container>
            </ThemeProvider>
            <Grid item xs={12} sm={10} md={8} lg={6} marginTop="40px">
                <NewVersionAbstractFooter />
            </Grid>
        </div>
    );
}

export default ConferenceBankPayemntForm;
